module.exports = __webpack_public_path__ + "45639cf394e13a96c04b84d322d62ef9.svg";